<template lang="pug">
  div
    validation-provider(:rules="requiredFields", v-slot="{ errors }", :name="validatorName")
      app-label(:label="getLabel()", :required="required")
      el-date-picker.input.date(
        v-bind="$attrs",
        type="date",
        placeholder="Selecione",
        format="dd/MM/yyyy",
        v-model="parent.date",
        :name="label",
        :picker-options="pickerOptions"
        :class="{'erro' : errors.length}"
      )
      span.help.erro {{ errors[0] }}
</template>

<script>
import AppLabel from './AppLabel'

export default {
  components: {
    AppLabel
  },

  props: {
    parent: {
      required: true
    },
    label: {
      type: String,
      required: true
    },
    fieldName: {
      type: String,
      required: true
    },
    validatorName: {
      type: String,
      required: true
    },
    valor: {
      required: true
    },
    required: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      }
    }
  },

  computed: {
    requiredFields () {
      return this.required ? 'required' : ''
    }
  },

  methods: {
    getFieldName (fieldName) {
      return `${this.scope}.${fieldName}`
    },
    getLabel () {
      return `${this.label}:`
    }
  }
}
</script>

<style lang="scss" scoped>
  .date {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/AppData.vue